import React, { Component } from 'react';
import Side from '../../components/side';
import CompetitionList from '../../pages/CompetitionList';
import styles from './style.less';
import { get, post } from '../../commons/http';
import { connect } from 'react-redux';
import { updateCompetitionInfo } from '../../store/competition/action';
import Search from './Search';
import { Modal, DatePicker, Checkbox, message } from 'antd';
import moment from 'moment';

const dataSource = [
  {
    key: 'competition',
    text: '竞赛',
    icon: 'book',
    path: '',
    children: [
      {
        key: 'all',
        text: '所有',
        icon: 'align-left',
        path: '/home/competition/all',
      },
      {
        key: 'active',
        text: '进行中',
        icon: 'align-left',
        path: '/home/competition/active',
      },
      {
        key: 'before',
        text: '未开始',
        icon: 'align-left',
        path: '/home/competition/before',
      },
      {
        key: 'after',
        text: '已结束',
        icon: 'align-left',
        path: '/home/competition/after',
      },
    ],
  },
  {
    key: 'my',
    text: '我的',
    icon: 'user',
    path: '',
    children: [
      {
        key: 'signUp',
        text: '已报名',
        icon: 'align-left',
        path: '/home/competition/my',
      },
    ],
    // order: 900,
  },
  {
    key: 'portal',
    text: '返回官网',
    icon: 'home',
    path: '/',
    external: true, //整页跳转回官网首页
  },
];

class Competition extends Component {
  state = {
    allCompetitions: [],
    signUpCompetition: [],
    competitions: [],
    keyword: '',
    // 管理员调整报名时间
    deadlineModal: { visible: false, competition: null },
    deadlineTime: null, //新报名截止时间
    deadlineStartTime: null, //新报名开始时间（可选）
    deadlineForceOpen: false, //立即开放报名（清空开始时间）
    deadlineSaving: false,
  };

  componentDidMount() {
    const getSignUpCompetition = async () => {
      const { data, code } = await get('/user/getSignUpCompetition');
      if (code === 0) {
        let signUpCompetition = [];
        for (let i = 0; i < data.signUpCompetition.length; i++) {
          signUpCompetition.push(data.signUpCompetition[i].competition);
        }
        this.setState({ signUpCompetition });
      }
    };

    this.fetchCompetitions();
    getSignUpCompetition();
  }

  // 拉取全部赛事（保存报名时间后复用刷新）
  fetchCompetitions = async () => {
    const response = await get('/competition/all');
    this.props.updateCompetition(response.data.competitions);
    this.setState({ allCompetitions: response.data?.competitions });
  };

  // 打开「调整报名时间」弹窗（管理员）
  openDeadlineModal = (competition) => {
    this.setState({
      deadlineModal: { visible: true, competition },
      deadlineTime: competition.end_time
        ? moment(competition.end_time)
        : null,
      deadlineStartTime: competition.start_time
        ? moment(competition.start_time)
        : null,
      deadlineForceOpen: !competition.start_time,
    });
  };

  closeDeadlineModal = () => {
    this.setState({
      deadlineModal: { visible: false, competition: null },
      deadlineTime: null,
      deadlineStartTime: null,
      deadlineForceOpen: false,
    });
  };

  // 提交新的报名时间
  submitDeadline = async () => {
    const {
      deadlineModal,
      deadlineTime,
      deadlineStartTime,
      deadlineForceOpen,
    } = this.state;
    const competition = deadlineModal.competition;
    if (!competition) return;
    if (!deadlineTime) {
      message.error('请选择报名截止时间', 1);
      return;
    }
    if (
      !deadlineForceOpen &&
      deadlineStartTime &&
      deadlineStartTime.isAfter(deadlineTime)
    ) {
      message.error('开始时间不能晚于截止时间', 1);
      return;
    }
    this.setState({ deadlineSaving: true });
    const payload = {
      competitionId: competition._id,
      end_time: deadlineTime.format('YYYY-MM-DD HH:mm:ss'),
    };
    if (deadlineForceOpen) {
      payload.forceOpen = true;
    } else if (deadlineStartTime) {
      payload.start_time = deadlineStartTime.format('YYYY-MM-DD HH:mm:ss');
    }
    const response = await post('/competition/updateDeadline', payload);
    this.setState({ deadlineSaving: false });
    if (response.code === 0) {
      message.success('报名时间已更新', 1);
      this.closeDeadlineModal();
      this.fetchCompetitions();
    } else {
      message.error(response.msg || '保存失败，请重试', 2);
    }
  };

  getCompetitions = () => {
    const tag = this.props.match.params.tag; //获取到tag
    const { allCompetitions, signUpCompetition } = this.state;
    if (tag === 'all') return allCompetitions; //返回所有竞赛
    if (tag === 'my') return signUpCompetition; //返回1⃣️报名竞赛
    const status = tag == 'before' ? 0 : tag == 'active' ? 1 : 2; //返回对应状态（未开始、进行中、已结束）的竞赛
    return allCompetitions.filter((competition) => {
      return competition.status == status;
    });
  };

  handleSearch = (keyword) => {
    this.setState({ keyword });
  };

  render() {
    const { keyword } = this.state;
    let competitions = this.getCompetitions();
    if (keyword !== '') {
      competitions = competitions.filter((competition) => {
        return (
          competition.title.includes(keyword) ||
          competition.desc.includes(keyword)
        );
      });
    }
    // 管理员额外显示「用户管理」入口
    const user = JSON.parse(window.localStorage.getItem('user') || '{}');
    const menus =
      user.role === 'admin'
        ? [
            ...dataSource.slice(0, 2),
            {
              key: 'userManage',
              text: '用户管理',
              icon: 'team',
              path: '/home/user-manage',
            },
            dataSource[2],
          ]
        : dataSource;
    return (
      <div className={styles['page-container']}>
        <Side sideWidth={210} menus={menus} style={{ top: '55px' }} />
        <div className={styles['ambient']} aria-hidden="true">
          <div className={`${styles.blob} ${styles.b1}`} />
          <div className={`${styles.blob} ${styles.b2}`} />
          <div className={styles.scanline} />
        </div>
        <div className={styles['competition-list']}>
          <div className={styles['page-hero']}>
            <span className={styles['hero-kicker']}>SuperMap GIS · 超图杯</span>
            <h1>
              竞赛<span className={styles.accent}>地图</span>
            </h1>
            <p>
              以地理智慧，连接每一场赛事 —— 在线报名，作品请发送至
              3032365889@qq.com
            </p>
            <div className={styles['hero-groups']}>
              <div className={styles['group-card']}>
                <div className={styles['group-name']}>
                  制图组<span className={styles['group-badge']}>自由选题</span>
                </div>
                <p className={styles['group-desc']}>
                  通过数据的加工处理和制图表达手段，创作具有特色风格的专题平面地图。作品须基于
                  SuperMap GIS 系列软件完成。
                </p>
              </div>
              <div className={styles['group-card']}>
                <div className={styles['group-name']}>
                  开发组<span className={styles['group-badge']}>自由选题</span>
                </div>
                <p className={styles['group-desc']}>
                  结合当前主流 GIS 技术，设计并开发应用系统，体现 GIS
                  在各个领域的应用价值。作品须基于 SuperMap GIS 系列软件完成。
                </p>
              </div>
            </div>
          </div>
          <Search
            styles={{ marginLeft: '6px' }}
            handleSearch={this.handleSearch}
          ></Search>
          <CompetitionList
            tag={this.props.match.params.tag}
            competitions={competitions}
            onAdjustDeadline={this.openDeadlineModal}
          ></CompetitionList>
        </div>
        <Modal
          title="调整报名时间"
          visible={this.state.deadlineModal.visible}
          onOk={this.submitDeadline}
          onCancel={this.closeDeadlineModal}
          confirmLoading={this.state.deadlineSaving}
          okText="保存"
          cancelText="取消"
          destroyOnClose
        >
          {this.state.deadlineModal.competition && (
            <div>
              <p>
                <b>赛事：</b>
                {this.state.deadlineModal.competition.title}
              </p>
              <p style={{ color: '#8ea3b8' }}>
                当前：{this.state.deadlineModal.competition.start_time ||
                  '不限制'}{' '}
                ~ {this.state.deadlineModal.competition.end_time || '未设置'}
              </p>
              <div style={{ marginTop: 12 }}>
                <Checkbox
                  checked={this.state.deadlineForceOpen}
                  onChange={(e) =>
                    this.setState({ deadlineForceOpen: e.target.checked })
                  }
                >
                  立即开放报名（不限制开始时间）
                </Checkbox>
              </div>
              {!this.state.deadlineForceOpen && (
                <div style={{ marginTop: 12 }}>
                  <span style={{ display: 'block', marginBottom: 4 }}>
                    报名开始时间（不选则保持原设置）
                  </span>
                  <DatePicker
                    showTime
                    style={{ width: '100%' }}
                    placeholder="选择开始时间"
                    value={this.state.deadlineStartTime}
                    onChange={(v) =>
                      this.setState({ deadlineStartTime: v })
                    }
                  />
                </div>
              )}
              <div style={{ marginTop: 12 }}>
                <span
                  style={{
                    display: 'block',
                    marginBottom: 4,
                    color: '#c0392b',
                  }}
                >
                  报名截止时间（必选）
                </span>
                <DatePicker
                  showTime
                  style={{ width: '100%' }}
                  placeholder="选择截止时间"
                  value={this.state.deadlineTime}
                  onChange={(v) => this.setState({ deadlineTime: v })}
                />
              </div>
            </div>
          )}
        </Modal>
      </div>
    );
  }
}

export default connect(
  (state) => {
    const { userInfo } = state;
    return { userInfo };
  },
  (dispatch) => {
    return {
      updateCompetition: (data) => {
        dispatch(updateCompetitionInfo(data));
      },
    };
  }
)(Competition);
